import React from 'react';

export default () => (
  <div className="c-heading c-heading--small u-mt">
    No brand shops are currently set up.&nbsp;
    To add a shop, you can do so from the shop page.
  </div>
);
